import styled from 'styled-components';
import * as Common from '../../../../../Styles';

const Theme = Common.Theme;

export const VerticalDivision = styled.div`
	display: flex;
	flex: 1;
	width: 1px;
	height: calc(100vh - 6.2rem);
	border: 1px solid ${Theme.lightGrey};
`;

export const Sidebar = styled(Common.Container)`
	max-width: 15rem;
	padding: 0 2rem;
	gap: 0.75rem;
`;

export const TitleSection = styled(Common.TitleSection)`
	margin: 0.5rem 0 0.25rem;
`;

export const TitleColumn = styled(Common.FlexColumn)`
	flex-grow: 1;
	flex: auto;
`;

export const TableContainer = styled(Common.TableContainer)`
	height: calc(100vh - 12.6rem) !important;
`;
